<template>
  <a-layout style="background: #EFEFEF">
    <a-layout-sider v-if="!isPhone" style="background: #fff" v-model:collapsed="collapsed" :trigger="null" collapsible>
      <div class="logo" style="text-align: center">
        <img src="./assets/vipaper.logo.jpg" width="60%" alt="">
      </div>
      <h3 class="menu" @click="()=>goToPage('/paper/upload')" style="cursor: pointer">
        <FilePdfOutlined/>
        <span v-if="!collapsed"> 新阅读</span>
      </h3>
      <div class="menu">
        <paper-recent :collapsed="collapsed" :account="account"/>
      </div>
      <a-menu
              mode="inline"
              :selectedKeys="selectedKeys"
              @click="handleMenuClick"
              :items="[...itemsRight]"
      />
    </a-layout-sider>
    <a-layout>

      <a-layout-content class="paper-layout-content">
        <!-- 响应式导航栏 -->
        <div v-if="isPhone" style="padding: 0; height: 83vh;">
          <!-- 移动端汉堡按钮 -->
<!--          <menu-fold-outlined v-if="!collapsed" class="trigger" @click="() => (collapsed = !collapsed)" />-->
          <div
                  v-if="showMobileMenu && collapsed"
                  :closable="false"
                  :visible="collapsed"
                  @close="closeDrawer"
          >
            <h3 class="menu" @click="()=>goToPage('/paper/upload')" style="cursor: pointer">
              <FilePdfOutlined/>
              <span> 新阅读</span>
            </h3>
            <h3 class="menu">
              <ClockCircleOutlined @click="()=>handleMenuClick({key: 'recent'})"/> 最近阅读
            </h3>
            <h3 class="menu">
              <UserOutlined/> <span v-if="account" @click="()=>handleMenuClick({key: 'account'})">个人中心</span>
              <span v-else @click="()=>handleMenuClick({key: 'Login'})">登录/注册</span>
            </h3>
          </div>
          <div v-else>
            <router-view v-slot="{ Component }">
              <keep-alive>
                <component :is="Component" />
              </keep-alive>

            </router-view>
          </div>

        </div>
        <!-- App.vue 或其他布局组件 -->
        <div v-else>
          <router-view v-slot="{ Component }">
            <keep-alive>
              <component :is="Component" />
            </keep-alive>

          </router-view>
        </div>

        <a-modal v-model:open="openLogin" @ok="()=>onOk" width="400px" :footer="null">
          <LoginView/>
        </a-modal>
      </a-layout-content>
      <a-layout-footer style="text-align:center" v-if="(!isPhone) || (isPhone && isPhoneHome)">
        <p>VIPaper © 2025 至今</p>
        <p><a href="https://beian.miit.gov.cn/" target="_blank">京公网安备 京ICP备18001696号-6</a> </p>
      </a-layout-footer>
    </a-layout>
  </a-layout>

</template>

<script setup>
  import { ref, computed, onMounted, onBeforeUnmount } from 'vue';
  import {getAccount, goToLogin, isMobile} from "./utils/llm.tools";
  import LoginView from "./views/LoginView";
  import {h} from 'vue';
  import {
    UserOutlined, FilePdfOutlined,
    ClockCircleOutlined
  } from '@ant-design/icons-vue';

  import PaperRecent from "./views/PaperRecent";
  // import {get_user} from './utils/api';
  // 响应式逻辑
  // 响应式逻辑
  const screenWidth = ref(window.innerWidth);
  const drawerVisible = ref(true);
  const openLogin = ref(false);
  const selectedKeys = ref(['home']);
  const isPhone = ref(isMobile());
  const isPhoneHome = window.location.href === '/mobile/phone';
  const updateScreenWidth = () => {
    screenWidth.value = window.innerWidth;
  };


  onBeforeUnmount(() => {
    window.removeEventListener('resize', updateScreenWidth);
  });

  // 是否显示移动菜单按钮
  const showMobileMenu = computed(() => {
    return screenWidth.value < 768;
  });
  let account = getAccount();
  let itemsRight = [];
  if(!account){
    itemsRight = [
      {key: 'Login', label: '登录/注册'},
    ]
  } else{

    itemsRight = [
      {
        key: 'Login', label: account, title: account,
        icon: ()=> h(UserOutlined),
        children: [
          {
            key: 'account', label: '个人中心',
          },
          {
            key: 'logout', label: '退出'
          },
        ]
      }
    ];
  }
  // 菜单数据
  // 菜单点击处理
  // const handleMenuClick2 = ({ key }) => {
  //   console.log('Menu clicked:', key);
  //   if(key === 'logout') {
  //     localStorage.clear();
  //     window.location.href = '/login';
  //   }
  //   else window.location.href = '/' + key;
  //   if (screenWidth.value < 768) {
  //     drawerVisible.value = false;
  //   }
  // };

  // 抽屉控制
  const collapsed = ref(false);
  const closeDrawer = () => {
    drawerVisible.value = false;
  };

  // const showHeader = !window.location.pathname.startsWith('/push') ? true: account;


  // // 是否显示移动菜单按钮
  // const showMobileMenu = computed(() => {
  //   // return screenWidth.value < 768;
  //   return true
  // });
  onMounted(() => {
    window.addEventListener('resize', updateScreenWidth);
    // if(getAccount()){
    //   get_user((res)=>{
    //     let {level, tel} = res?.data || {};
    //     console.log('level', level);
    //     localStorage.setItem('level', level);
    //     localStorage.setItem('tel', tel);
    //   })
    // }
  });

  onBeforeUnmount(() => {
    window.removeEventListener('resize', updateScreenWidth);
  });

  // 菜单数据
  // 菜单点击处理
  const handleMenuClick = ({ key }) => {
    console.log('Menu clicked:', key);
    if(key === 'Login') {
      openLogin.value = true;
    }
    else if(key === 'logout') {
      localStorage.clear();
      window.location.reload();
    }
    else window.location.href = '/' + key;
    if (screenWidth.value < 768) {
      drawerVisible.value = false;
    }
  };
  const goToPage = (url)=>{
    if(account) window.location.href = url;
    else if(isMobile()) goToLogin();
    else openLogin.value = true;
  }
</script>
<style scoped>
  /*@import url('./main.css');*/
  .menu {
    padding-left: 20px;
    margin-top: 20px;
    background: #FFF;
    border-radius: 8px;
    line-height: 40px;
  }
  #components-layout-demo-custom-trigger .trigger {
    font-size: 18px;
    line-height: 64px;
    padding: 0 24px;
    cursor: pointer;
    transition: color 0.3s;
  }

  #components-layout-demo-custom-trigger .trigger:hover {
    color: #1890ff;
  }

  #components-layout-demo-custom-trigger .logo {
    height: 32px;
    background: rgba(255, 255, 255, 0.3);
    margin: 16px;
  }

  .site-layout .site-layout-background {
    background: #fff;
  }
  .header {
    /*display: flex;*/
    justify-content: space-between;
    padding: 0 20px;
    /*background: #fff;*/
  }

  .mobile-trigger {
    /*color: white;*/
    font-size: 18px;
    cursor: pointer;
    padding: 0 12px;
    color: #fff;
  }

  @media (max-width: 767px) {
    .desktop-menu {
      display: none;
    }
    .header{
      /*background: #1F4E79;*/
    }
  }
  .paper-layout-content{
    margin: 24px 16px; padding: 24px; background: #fff; min-height: 280px
  }
  @media (min-width: 768px) {

    .header{
      background: #fff;
      border-bottom: 1px solid rgba(0,0, 0, 0.085);
    }
    .mobile-trigger {
      display: none;
    }
  }
  /* 当视口宽度小于 600px 时 */
  @media (max-width: 480px) {
    .paper-layout-content{
      margin: 0;
      padding: 10px;
      background: #FFF
      /*background: #F6F3F6*/
    }
  }
</style>
